import { FormattedMessage } from 'react-intl';
import { Questions } from '../questions';
import { Waiver } from '../waivers';
import {
  AdditionalInformationContainer,
  SectionHeader,
  SectionTitle,
  FormFieldsContainer,
  QuestionsContainer,
  WaiverContainer,
} from './styles';

interface AdditionalInformationProps {
  questionsProps: any;
  waiverProps: any;
  showQuestions: boolean;
  showWaiver: boolean;
  stepNo: number;
  isLiveBooking?: boolean;
  borderless?: boolean;
  fields: any;
  errors: any;
  onChange?: (
    position: number,
    value: string,
    nameField: string,
    unitTypeId: number
  ) => void;
}

export const AdditionalInformation = ({
  questionsProps,
  waiverProps,
  showQuestions,
  showWaiver,
  isLiveBooking = false,
  borderless = false,
  fields,
  errors,
  onChange,
}: AdditionalInformationProps) => {
  const questionsPropsWithForm = {
    ...questionsProps,
    errors,
    renderBottomBorder: showWaiver,
    onChange: questionsProps?.onChange,
  };

  const waiverPropsWithForm = {
    ...waiverProps,
    fields,
    errors,
    ...(onChange ? { onChange } : {}),
  };

  return (
    <AdditionalInformationContainer
      isLive={isLiveBooking}
      borderless={borderless}
      data-testid="additional-information-section"
    >
      <SectionHeader>
        <SectionTitle>
          <FormattedMessage
            defaultMessage="Additional Information"
            description="Additional information section title"
          />
        </SectionTitle>
      </SectionHeader>

      <FormFieldsContainer borderless={borderless}>
        {showQuestions && (
          <QuestionsContainer hasWaiver={showWaiver}>
            <Questions {...questionsPropsWithForm} />
          </QuestionsContainer>
        )}

        {showWaiver && (
          <WaiverContainer>
            <Waiver {...waiverPropsWithForm} />
          </WaiverContainer>
        )}
      </FormFieldsContainer>
    </AdditionalInformationContainer>
  );
};
